import React from "react";
import {Avatar} from "antd";
import {useNavigate} from "react-router-dom";

const ProfileComponent = ({user}) => {
    const navigate = useNavigate()

    if (!user) {
        return <p>No user information available</p>
    }
    return (
        <div onClick={() => navigate("/profile")}
             style={{display: 'flex', alignItems: 'center', cursor: "pointer", gap: '10px'}}>
            <p>{user.firstName}</p>
            <Avatar src={user.profile_picture}/>
        </div>
    )
}

export default ProfileComponent;